import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/CookieAccessor.js";

/**
    * class HSN.AccountNavigation
    *
    * Encapsulates the functionality of the HSN account bar across the top of the
    * page and exposes methods to manipulate and update its contents.
    **/
HSN.AccountNavigation = function (config) {
    /**
        * new HSN.AccountNavigation(config)
        * - config (Object): A configuration object for the [[HSN.AccountNavigation]]
        *   consisting of the following keys:
        *   - cabinet (HSN.AccountNavigation.Cabinet): The [[HSN.AccountNavigation.Cabinet]] instance that will exist within this [[HSN.AccountNavigation]].
        *   - container (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element to act as the root container for the [[HSN.AccountNavigation]].
        *   - drawerParent (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element to act as the root container provided [[HSN.AccountNavigation.Cabinet]].
        *   - account (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the account link.
        *   - signin (string | HTMLElement | jQuery): A jQuery object, HTML element, or CSS selector that will ultimately resolve to an HTML element that contains the signin link.
        *   - noajax (boolean | value | jQuery): A boolean value to indicate whether the loaded account navigation can make use of ajax functionality.
        **/
    config = (config = config || {});
    this.noAjax = config.noajax;
    this.noUpdateState = config.noUpdateState;
    this.Container = $(config.container);
    this.DrawerParent = $(config.drawerParent);

    this.Cabinet = config.cabinet;

    this.AccountListItem = $(config.account);
    this.WelcomeListItem = $(config.welcome);
    this.SignInListItem = $(config.signin);
    this.SignOutListItem = $(config.signout);
    this.AlertListItem = $(config.alert);
    this.AlertCount = $(config.alertCount);
    this.CustomerStateEnum = {
        COLD: 0,
        WARM: 1,
        HOT: 2
    };
    this.CustomerState = 0;

    if (!this.noUpdateState) {
        this.UpdateState();
    }

    this.Cabinet.Root.hide();
    this.DrawerParent.append(this.Cabinet.Root);
};
HSN.AccountNavigation.prototype =
{
    _application: null,
    noAjax: null,
    Cabinet: null,
    AccountListItem: null,
    WelcomeListItem: null,
    SignInListItem: null,
    SignOutListItem: null,
    AlertListItem: null,
    AlertCount: null,

    /**
        * HSN.AccountNavigation#UpdateState -> void
        *
        * Updates the state of the [[HSN.AccountNavigation]]'s information and
        * display with data retrieved from the payload service such as
        *  - The visitor's name
        *  - Whether the visitor is signed in or not
        *  - The number of alerts the visitor has
        *  - The number of items in the visitors bag
        **/
    UpdateState: function () {
        if (this.noAjax || HSN.GetHsnArcadeObjectName() !== null) {
            this.SetAuthenticatedState(false);
            this.Container.animate({ opacity: 1 });
        }
        else {
            var offerLocations = [];
            $("[offer-location]").each(function () {
                offerLocations.push($(this).attr('offer-location'));
            });
            var ifFromIframe = this.FromIframe();
            $.ajax
            (
                "/account/status",
                {
                    context: this,
                    dataType: 'json',
                    cache: false,
                    data: {
                        offerLocations: offerLocations,
                        ifFromIframe: ifFromIframe
                    },
                    traditional: true,
                    success: function (data, status, xhr) {
                        this._application.Events.Trigger(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_COMPLETE, data);
                        HSN.SetBagIconCount(data.bagItems);
                        this.SetServerTime(data.serverTime);
                        this.SetCustomerState(data.custState);
                        this.SetAuthenticatedState(data.isAuthenticated, data.name);
                        this.SetNewSession(data.session);
                        this.Container.animate({ opacity: 1 });
                        if (data.displayEmailCapture) {
                            this.ShowEmailCapture(data.emailCaptureMethod);
                        }
                          
                        if (data.customerOffers) {
                            this.DisplayCustomerOffers(data.customerOffers);
                        }

                        if (data.showKashModal) {
                            this.ShowKashModal();
                        }

                        if (data.showMarketingDrawer) {
                            var refToken = HSN.Instance().GetQueryStringParam(window.location.search, 'cm_mmc');
                            if (refToken.toUpperCase().indexOf('AFFILIATEPARTNER-_-UNIVISION') == 0) {
                                HSN.Instance().AccountNavigation.Cabinet.Open(new HSN.AccountNavigation.Cabinet.Drawer({ identifier: 'first-time-visit', url: '/firsttimevisit' }));
                            }
                        }

                        if (data.isCountryCa) {
                            this.SetServerCountry(data.isCountryCa);
                        }

                        if (sessionStorage["customerState"] != data.custState || location.pathname.toLowerCase() == "/profile") {
                            this.ClearSessionFavoriteData();
                        }

                        sessionStorage["customerState"] = data.custState;

                        HSN.Instance().SetAccountStatusData(data);
                    }
                }
            );
            $.ajax
            (
                "/account/status-detail",
                {
                    context: this,
                    dataType: 'json',
                    cache: false,
                    data: {},
                    traditional: true,
                    success: function (data, status, xhr) {
                        this._application.Events.Trigger(HSN.AccountNavigation.EVENT.ACCOUNT_STATUS_DETAIL_COMPLETE, data);
                        HSN.Instance().SetAccountStatusDetailData(data);

                        HSN.Bazaarvoice.SetPageMetaTag(data.BazaarVoiceUasToken);
                        HSN.OnAdobeTargetLoad(function () {
                            setTimeout(HSN.Bazaarvoice.Load, 250);
                        })
                    },
                    error: function () {
                        HSN.OnAdobeTargetLoad(function () {
                            setTimeout(HSN.Bazaarvoice.Load, 250);
                        })
                    }
                }
            );
        }
    },
    FromIframe: function () {
        try {
            return window.self != window.top;
        } catch (e) {
            return true;
        }
    },
    ShowKashModal: function () {
        $.ajax
            (
                "/account/kashreminder/check",
                {
                    context: this,
                    dataType: 'json',
                    timeout: 5000,
                    success: function (data, status, xhr) {
                        if (data.HasKash) {
                            HSN.Instance().GetKashReminderModal().Show(data.KashAmt);
                        }
                    }
                }
            );
    },

    ShowEmailCapture: function () {
        HSN.Instance().GetEmailCaptureModal().Show();
    },

    SetServerTime: function (time) {
        if (!this.noAjax) {
            if (time) {
                $('#server-name').data('time', time);
            }
        }
    },

    SetServerCountry: function (country) {
        if (country) {
            $('#server-name').attr('is-country-ca', 'true');
        }
    },

    /**
        * HSN.AccountNavigation#SetNewSession(session) -> void
        * - session (String): The cust_ID of the new session - or null;
        *
        * Throws core metrics registration call
        **/
    SetNewSession: function (session) {
        if (session != "") {
            if (typeof (cG7) != 'undefined') {
                cmCreateRegistrationTag(session, '', '', '', '', '', '');
            } else {
                HSN.Instance().Events.On(HSN.Application.EVENT.CM_LOADED, function () {
                    cmCreateRegistrationTag(session, '', '', '', '', '', '');
                });
            }
        }
    },

    /**
        * HSN.AccountNavigation#SetApplicationInstance(application) -> void
        * - application (HSN.Application): The [[HSN.Application]] instance this [[HSN.AccountNavigation]] should coordinate with.
        *
        * Sets the [[HSN.Application]] instance this [[HSN.AccountNavigation]] should coordinate with for events
        * and other interactions.
        **/
    SetApplicationInstance: function (application) {
        this._application = application;
        this._application.Events.On
        (
            HSN.Application.EVENT.VISITOR_AUTHENTICATED,
            function () {
                this.UpdateState();
            },
            this
        );
    },

    /**
        * HSN.AccountNavigation#SetAuthenticatedState(isAuthenticated) -> void
        * - isAuthenticated (Boolean): Whether or not the visitor is authenticated.
        *
        * Set's the state of the account navigation to display information
        * conditionally based on the new value of whether the visitor is
        * authenticated.
        **/
    SetAuthenticatedState: function (isAuthenticated, name) {
        var custState = this.GetCustomerState();
        this.AccountListItem[isAuthenticated || (custState == this.CustomerStateEnum.WARM) ? 'show' : 'hide']();
        this.SignOutListItem[isAuthenticated || (custState == this.CustomerStateEnum.WARM) ? 'show' : 'hide']();
        this.SignInListItem[isAuthenticated || (custState == this.CustomerStateEnum.WARM) ? 'hide' : 'show']();
        this.WelcomeListItem[isAuthenticated || (custState == this.CustomerStateEnum.WARM) ? 'hide' : 'show']();

        if (this.SignOutListItem && (isAuthenticated || this.GetCustomerState() == this.CustomerStateEnum.WARM)) {
            var displayName = name && name.length > 15 ? name.substring(0, 15) : name;
            $('#utility-nav-signout span').html("Hello, " + displayName);
        }
    },

    /**
        * HSN.AccountNavigation#DisplayCustomerPromotions(promotions) -> void
        * Overrides content areas with possible customer specific promotions
    **/
    DisplayCustomerOffers: function (offers) {
        this._application.DisplayCustomerOffers(offers);
    },
    /**
    * HSN.AccountNavigation#SetCustomerState(state) -> void
    * - state (number): the state the customer is in : cold: 0, warm: 1, hot: 2
    *
    * Sets the state the customer is in : cold: 0, warm: 1, hot: 2
    **/
    SetCustomerState: function (state) {
        this.CustomerState = state;
    },

    /**
    * HSN.AccountNavigation#GetCustomerState(state) -> void
    * returns the state the customer
    **/
    GetCustomerState: function () {
        return this.CustomerState;
    },

    ClearSessionFavoriteData: function () {
        if (Modernizr.sessionstorage) {
            sessionStorage.removeItem("hasCheckedFavorites");
            //remove favorited products...
            for (var key in sessionStorage) {
                if (key.indexOf('fav-') == 0) {
                    sessionStorage.removeItem(key);
                }
            }
        }
    }

};
/**
    * HSN.AccountNavigation.EVENT = Object
    *
    * An enumeration of events an [[HSN.AccountNavigation]] can raise:
    * - ACCOUNT_STATUS_COMPLETE: Fires when account status is complete.
    **/
HSN.AccountNavigation.EVENT =
{
    ACCOUNT_STATUS_COMPLETE: 'HSN.AccountNavigation:ACCOUNT_STATUS_COMPLETE',
    ACCOUNT_STATUS_DETAIL_COMPLETE: 'HSN.AccountNavigation:ACCOUNT_STATUS_DETAIL_COMPLETE'
};



// WEBPACK FOOTER //
// ./assets/js/HSN/AccountNavigation.js